import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import axios from 'axios';

import type { IMenuItem } from 'src/models/IMenu';

import { Icon } from '@nebo-team-dev/vobaza.ui.icon/dist';
import CitySelect from '../../CitySelect';
import { MobileMenuBlock } from './ui/MobileMenuBlock';

import type { MenuProps } from '../types';

import styles from './styles.module.scss';
import Preloader from 'shared/ui/Preloader';

export const HeaderMiddleMobileMenu: FC<MenuProps> = ({ isOpen, close }) => {
  const [currentMenuItem, setCurrentMenuItem] = useState<IMenuItem | null>(null);
  const [mobMenu, setMobMenu] = useState<null | IMenuItem[]>(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchMobileMenu = async () => {
    setIsLoading(true);
    try {
      const resp = await axios.get('/api/menu?type=MOBILE');
      setMobMenu(resp?.data || null);
    } catch (error) {
      console.error(error);
    }

    setIsLoading(false);
  };

  const resetMenuItem = () => {
    setCurrentMenuItem(null);
  };

  const closeHandler = () => {
    resetMenuItem();
    close();
  };

  useEffect(() => {
    if (isOpen) {
      if (!mobMenu) {
        fetchMobileMenu();
      }
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'auto';
    }
  }, [isOpen]);

  return (
    <div className={styles.headerMobileMenu}>
      <div className={`${styles.headerMobileMenuHeader}`}>
        {currentMenuItem && (
          <>
            <button className={styles.headerMobileMenuClose} onClick={resetMenuItem}>
              <Icon name="ArrowLeft" />
            </button>
            <div className={styles.headerMobileMenuTitle}>{currentMenuItem.name}</div>
          </>
        )}
        <button className={styles.headerMobileMenuClose} onClick={closeHandler}>
          <Icon name="Cross" />
        </button>
        {!currentMenuItem && (
          <>
            <Link href="/" className={styles.headerMobileMenuLogo}>
              <Icon name="VobazaLogo" />
            </Link>
            <a className={styles.headerMobileMenu__phone} href="tel:+74958990909">
              {/* <a className={styles.headerMobileMenu__phone} href="tel:+88005055355"> */}
              <Icon name="Phone" />
            </a>
          </>
        )}
      </div>
      {currentMenuItem ? (
        <>
          <div className={styles.headerMobileMenuSubBlock}>
            {currentMenuItem.link && (
              <div className={styles.headerMobileMenuSubTitle}>
                <Link href={currentMenuItem.link || '/'}>Все товары раздела</Link>
              </div>
            )}
            {currentMenuItem?.children?.map((child) => (
              <MobileMenuBlock key={child.id} item={child} onClose={close} />
            ))}
          </div>
        </>
      ) : (
        <>
          <div className={styles.headerMobileMenuCity}>
            <CitySelect withoutFetch />
          </div>
          <div className={styles.headerMobileMenuBlock}>
            {!isLoading ? (
              <>
                {mobMenu?.map((item) => (
                  <MobileMenuGroup key={item.id} item={item} setCurrentMenuItem={setCurrentMenuItem} />
                ))}
              </>
            ) : (
              <div className={styles.preloaderWrap}>
                <Preloader />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

const MobileMenuGroup = ({
  item,
  setCurrentMenuItem,
}: {
  item: IMenuItem;
  setCurrentMenuItem: Dispatch<SetStateAction<IMenuItem>>;
}) => {
  return (
    <div key={item.id} className={styles.headerMobileMenuList}>
      <div className={styles.headerMobileMenuListTitle}>{item.name}</div>
      <div className={styles.headerMobileMenuContent}>
        {item.children?.map((menuItem) => (
          <div key={menuItem.id} className={styles.headerMobileMenuItem} onClick={() => setCurrentMenuItem(menuItem)}>
            {menuItem.icon && <Image src={menuItem.icon} width={28} height={28} alt="menu icon" />}
            <span>{menuItem.name}</span>
            <Icon name="SmallArrowUp" />
          </div>
        ))}
      </div>
    </div>
  );
};
